import {
  BACKOFFICE_LOGIN_REQUEST,
  BACKOFFICE_LOGIN_SUCCESS,
  BACKOFFICE_LOGIN_FAIL,
  BACKOFFICE_LOGOUT,
  BACKOFFICE_REGISTER_SUCCESS,
  BACKOFFICE_REGISTER_FAIL,
} from "../constants/backOfficeAuthActions";

const initialState = {
  loading: false,
  loginSucceeded: false,
  registerSucceeded: false,
  token: "",
  error: "",
  message: "",
};

// Persist/load helpers (sessionStorage used to keep session-scoped persistence)
function loadPersistedAuth() {
  try {
    const raw = sessionStorage.getItem("backOfficeAuthState");
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (e) {
    console.warn("Failed to load persisted backOfficeAuthState:", e);
    return null;
  }
}

function savePersistedAuth(state) {
  try {
    sessionStorage.setItem("backOfficeAuthState", JSON.stringify(state));
  } catch (e) {
    console.warn("Failed to save backOfficeAuthState:", e);
  }
}

function removePersistedAuth() {
  try {
    sessionStorage.removeItem("backOfficeAuthState");
  } catch (e) {
    /* ignore */
  }
}

// hydrate initial state with persisted values (persisted keys overwrite defaults)
const persistedAuth = loadPersistedAuth();
const hydratedInitialState = persistedAuth ? { ...initialState, ...persistedAuth } : initialState;

// inner reducer: same logic as before but uses hydratedInitialState
export const innerBackOfficeAuthReducer = (state = hydratedInitialState, action) => {
  switch (action.type) {
    case BACKOFFICE_LOGIN_REQUEST:
      return { ...state, loading: true };
    case BACKOFFICE_LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        loginSucceeded: true,
        token: action.payload,
      };
    case BACKOFFICE_LOGIN_FAIL:
      return {
        ...state,
        loading: false,
        loginSucceeded: false,
        error: action.payload,
      };
    case BACKOFFICE_LOGOUT:
      // reset to initial state on explicit logout
      return { ...initialState };
    case BACKOFFICE_REGISTER_SUCCESS:
      return { ...state, registerSucceeded: true, message: action.payload };
    case BACKOFFICE_REGISTER_FAIL:
      return { ...state, registerSucceeded: false, message: action.payload };
    default:
      return { ...state };
  }
};

// wrapper reducer: persist auth slice and clear persisted auth on logout
export const backOfficeAuthReducer = (state, action) => {
  const nextState = innerBackOfficeAuthReducer(state, action);

  // If logout, remove persisted auth and return nextState
  if (action && action.type === BACKOFFICE_LOGOUT) {
    removePersistedAuth();
    return nextState;
  }

  // Persist resulting auth state
  if (nextState && typeof nextState === "object") {
    savePersistedAuth(nextState);
  }

  return nextState;
};
